<template>
  <div
    ref="DivElement"
    id="imgEdit"
    class="fixed inset-0 overflow-y-auto"
    style="z-index: 500"
  >
    <div
      v-if="!chengeEditMode && currentUser.role_id !== 1"
      class="menu-wrap bg-blue"
      :hidden="hideMenu"
    >
      <div class="flex flex-row items-baseline ml-7 mt-2">
        <span class="text-white font-bold text-xl">黒塗りマスク作成</span>
        <span class="text-white font-bold text-md">モード</span>
        <button
          class="end-button-wrap bg-white text-blue font-bold text-xl mr-2"
          @click="chengeImgPreview"
        >
          <div class="circle bg-white">
            <close-icn
              width="15"
              height="15"
              class="fixed mt-0.5 ml-0.5"
              :class="`${color}-icon`"
            ></close-icn>
          </div>
          <span class="ml-5"> 終了</span>
        </button>
      </div>

      <button class="button-wrap bg-white text-blue" @click="setNewImage">
        <div class="mr-2 ml-2 mb-1" style="border-bottom: dotted;">
          <span class="font-bold text-xl">新規</span>
          <span class="font-bold text-md">モード</span>
        </div>
        現在のマスクを削除し<br />
        新たに作成します
      </button>
      <button class="button-wrap bg-white text-blue" @click="setImage">
        <div class="mr-2 ml-2 mb-1" style="border-bottom: dotted;">
          <span class="font-bold text-xl">追加</span>
          <span class="font-bold text-md">モード</span>
        </div>
        現在のマスクに<br />
        追加して作成します
      </button>
    </div>

    <div v-if="chengeEditMode" class="new-black-item bg-blue">
      <div class="flex flex-row items-baseline ml-7 mt-2">
        <span class="text-white font-bold text-lg">黒塗りマスク追加</span>
        <span class="text-white font-bold text-sm">モード</span>
        <button class="save-botton text-blue bg-white ml-3" @click="saveImage">
          <approved-icn
            width="20px"
            height="20px"
            style=" position:absolute; top:5px;left:3px;"
          />
          <span class="text-lg ml-5">保存</span>
          <span class="text-sm">する</span>
        </button>
        <button
          class="end-button-wrap bg-white text-blue font-bold text-lg mr-2"
          @click="endEditMode"
        >
          <div class="circle bg-white">
            <close-icn
              width="15"
              height="15"
              class="fixed mt-0.5 ml-0.5"
              :class="`${color}-icon`"
            ></close-icn>
          </div>
          <span class="ml-5"> 終了</span>
        </button>
      </div>
    </div>
    <div class="add-black-item"></div>

    <div
      v-if="!chengeEditMode && currentUser.role_id !== 1"
      class="circle-bottom bg-black opacity-50"
      :hidden="hideMenu"
    ></div>
    <span
      v-if="!chengeEditMode && currentUser.role_id !== 1"
      :hidden="hideMenu"
      class="text-white items-center"
      style="position: absolute; left:120px; z-index: 700; text-align: center;"
      >クリック・ドラッグで<br />
      黒塗りますが<br />
      作成できます</span
    >
    <div class="img-wrap overflow-y-auto">
      <img
        ref="image"
        class="preview-img"
        :style="
          imageAspectRatio > 5
            ? 'width:30%;height:auto;'
            : imageAspectRatio < 5 && imageAspectRatio >= 2
            ? 'width:50%;height:auto;'
            : imageAspectRatio < 2 && imageAspectRatio >= 1
            ? 'width:70%;height:auto;'
            : imageAspectRatio < 1
            ? 'width:100%;height:auto;'
            : 'width:100%;height:auto;'
        "
        v-if="img.normalImage"
        :src="
          img.blackImage == null || chengeImgPreviewFlag
            ? img.normalImage
            : img.blackImage
        "
      />
      <canvas
        id="canvas-display"
        :width="canvasWidth"
        :height="canvasHeight"
        ref="CanvasElement"
      ></canvas>
      <canvas id="canvas" :width="canvasWidth" :height="canvasHeight"></canvas>
    </div>
    <div
      class="close-button fixed top-0 right-0 mt-4 mr-4 border-2 border-l-0 h-10 border-blue bg-white"
    >
      <close-icn
        width="20"
        height="20"
        :class="`${color}-icon`"
        @click="closeImgPreview"
      ></close-icn>
      <app-img-prv-checkbox
        :fieldId="1"
        color="blue"
        v-model:showCheck="chengeImgPreviewFlag"
        value="黒塗り表示"
        @click="chengeImgPreview"
      />
    </div>
  </div>
</template>

<script>
import CloseIcn from '@/assets/icons/close.svg?inline'
import ApprovedIcn from '@/assets/icons/approved-blue.svg?inline'
import AppImgPrvCheckbox from '@/components/ui/AppImgPrvCheckbox'
import { ref, reactive, onMounted } from 'vue'
import { useDialog } from '@/services/useDialog'
import { usePoliticalActions } from '@/services/politicalAction/usePoliticalActions'
import { useReceipts } from '@/services/receiptsYokohama/useReceipts'
import { useCurrentUser } from '@/services/useCurrentUser'
export default {
  name: 'AppImgPreview_YOKOHAMA',

  components: {
    CloseIcn,
    ApprovedIcn,
    AppImgPrvCheckbox,
  },
  props: {
    color: {
      type: String,
      default: 'black',
    },
  },
  setup() {
    const CanvasElement = ref(null)
    const DivElement = ref(null)
    const image = ref('')
    const blackImagePreview = ref([])
    const chengeImgPreviewFlag = ref(false)
    const chengeEditMode = ref(false)
    const hideMenu = ref(false)
    const rectState = ref()
    const rectCtx = ref()
    const rectWidth = ref()
    const rectHeight = ref()
    const { currentPoliticalAction } = usePoliticalActions()
    const { currentReceipt } = useReceipts()
    const { putBlackImage, imgPreviewType, imgPreviewIndex } = useDialog()
    let canvasWidth = ref('')
    let canvasHeight = ref('')
    let imageAspectRatio = ref('')

    const state = reactive({
      canvas: [],
      rect_MousedownFlg: false,
      rect_fx: 0,
      rect_fy: 0,
      rect_ex: 0,
      rect_ey: 0,
    })
    const displayState = reactive({
      canvas: [],
    })

    onMounted(() => {
      let canvas = document.getElementById('canvas')
      let canvasDisplay = document.getElementById('canvas-display')
      let context = canvas.getContext('2d')
      let canvasDisplayContext = canvasDisplay.getContext('2d')
      state.canvas = canvasDisplayContext
      displayState.canvas = context
      const rect = image.value.getBoundingClientRect()
      imageAspectRatio.value = rect.height / rect.width
    })

    const OnMousedown = event => {
      if (rectCtx.value) {
        rectCtx.value = null
        rectState.value.rect_fx = null
        rectState.value.rect_fy = null
        rectWidth.value = null
        rectHeight.value = null
      }
      state.rect_MousedownFlg = true
      state.rect_fx = 0
      state.rect_fy = 0
      state.rect_ex = 0
      state.rect_ey = 0
      // 座標を求める
      const rect = event.target.getBoundingClientRect()
      state.rect_fx = event.clientX - rect.left
      state.rect_fy = event.clientY - rect.top
    }

    const OnMousemove = event => {
      if (state.rect_MousedownFlg) {
        // mousemoveする度に枠線を描画するため、過去の枠線を削除する
        if (rectCtx.value) {
          rectCtx.value.clearRect(0, 0, canvasWidth.value, canvasHeight.value)
        }
        const rect = event.target.getBoundingClientRect()
        // 座標を求める
        state.rect_ex = event.clientX - rect.left
        state.rect_ey = event.clientY - rect.top

        let ctx = state.canvas
        rectState.value = state

        const width = state.rect_ex - state.rect_fx
        const height = state.rect_ey - state.rect_fy
        rectWidth.value = width
        rectHeight.value = height
        // 枠線の描画
        ctx.strokeRect(state.rect_fx, state.rect_fy, width, height)
        rectCtx.value = ctx
      }
    }

    const OnMouseup = () => {
      // 枠線を削除
      if (rectCtx.value) {
        rectCtx.value.clearRect(0, 0, canvasWidth.value, canvasHeight.value)
      }
      // 矩形の描画
      state.rect_MousedownFlg = false
      displayState.canvas.fillStyle = '#000000'
      displayState.canvas.fillRect(
        rectState.value.rect_fx,
        rectState.value.rect_fy,
        rectWidth.value,
        rectHeight.value,
      )
    }

    const OnTouchstart = event => {
      state.rect_MousedownFlg = true
      state.rect_fx = 0
      state.rect_fy = 0
      state.rect_ex = 0
      state.rect_ey = 0

      const touchObject = event.changedTouches[0]
      const touchX = touchObject.pageX
      const touchY = touchObject.pageY

      // 要素の位置を取得
      const clientRect = event.target.getBoundingClientRect()
      const positionX = clientRect.left + window.pageXOffset
      const positionY = clientRect.top + window.pageYOffset

      // 要素内におけるタッチ位置を計算
      state.rect_fx = touchX - positionX
      state.rect_fy = touchY - positionY
    }

    const OnTouchmove = event => {
      if (state.rect_MousedownFlg) {
        const touchObject = event.changedTouches[0]
        const touchX = touchObject.pageX
        const touchY = touchObject.pageY

        // 要素の位置を取得
        const clientRect = event.target.getBoundingClientRect()
        const positionX = clientRect.left + window.pageXOffset
        const positionY = clientRect.top + window.pageYOffset

        state.rect_ex = touchX - positionX
        state.rect_ey = touchY - positionY

        let ctx = state.canvas

        // 矩形の描画
        const width = state.rect_ex - state.rect_fx
        const height = state.rect_ey - state.rect_fy
        ctx.fillRect(state.rect_fx, state.rect_fy, width, height)
      }
    }

    const OnTouchend = () => {
      state.rect_MousedownFlg = false
    }

    const setImage = () => {
      CanvasElement.value.addEventListener('mousedown', OnMousedown, false)
      CanvasElement.value.addEventListener('mousemove', OnMousemove, false)
      DivElement.value.addEventListener('mouseup', OnMouseup, false)
      // スマホ対応
      CanvasElement.value.addEventListener('touchstart', OnTouchstart, false)
      CanvasElement.value.addEventListener('touchmove', OnTouchmove, false)
      DivElement.value.addEventListener('touchend', OnTouchend, false)
      //画像オブジェクトを生成
      const img = new Image()
      const rect = image.value.getBoundingClientRect()
      img.src = currentImgPreview.value.blackImage

      chengeEditMode.value = true
      canvasWidth.value = rect.width
      canvasHeight.value = rect.height
      //画像をcanvasに設定
      img.onload = function() {
        let ctx = displayState.canvas
        ctx.drawImage(img, 0, 0, canvasWidth.value, canvasHeight.value)
      }
    }

    const setNewImage = () => {
      CanvasElement.value.addEventListener('mousedown', OnMousedown, false)
      CanvasElement.value.addEventListener('mousemove', OnMousemove, false)
      DivElement.value.addEventListener('mouseup', OnMouseup, false)
      // スマホ対応
      CanvasElement.value.addEventListener('touchstart', OnTouchstart, false)
      CanvasElement.value.addEventListener('touchmove', OnTouchmove, false)
      DivElement.value.addEventListener('touchend', OnTouchend, false)
      //画像オブジェクトを生成
      if (rectCtx.value) {
        rectCtx.value = null
        rectState.value.rect_fx = null
        rectState.value.rect_fy = null
        rectWidth.value = null
        rectHeight.value = null
      }
      const img = new Image()
      const rect = image.value.getBoundingClientRect()
      img.src = currentImgPreview.value.normalImage

      chengeEditMode.value = true
      canvasWidth.value = rect.width
      canvasHeight.value = rect.height
      //画像をcanvasに設定
      img.onload = function() {
        let ctx = displayState.canvas
        ctx.drawImage(img, 0, 0, canvasWidth.value, canvasHeight.value)
      }
    }

    // 新規モードor追加モード終了ボタン
    const endEditMode = () => {
      CanvasElement.value.removeEventListener('mousedown', OnMousedown)
      CanvasElement.value.removeEventListener('mousemove', OnMousemove)
      DivElement.value.removeEventListener('mouseup', OnMouseup)
      // スマホ対応
      CanvasElement.value.removeEventListener('touchstart', OnTouchstart)
      CanvasElement.value.removeEventListener('touchmove', OnTouchmove)
      DivElement.value.removeEventListener('touchend', OnTouchend)
      chengeEditMode.value = false
      canvasWidth.value = ''
      canvasHeight.value = ''
    }

    // blackImageに保存
    const saveImage = () => {
      CanvasElement.value.removeEventListener('mousedown', OnMousedown)
      CanvasElement.value.removeEventListener('mousemove', OnMousemove)
      DivElement.value.removeEventListener('mouseup', OnMouseup)
      // スマホ対応
      CanvasElement.value.removeEventListener('touchstart', OnTouchstart)
      CanvasElement.value.removeEventListener('touchmove', OnTouchmove)
      DivElement.value.removeEventListener('touchend', OnTouchend)
      const canvas = document.getElementById('canvas')
      const data = canvas.toDataURL('image/png')
      currentImgPreview.value.blackImage = data
      //  申請書
      if (imgPreviewType.value == 'request') {
        const imageData = currentPoliticalAction.application.images
        imageData.forEach(item => {
          if (img.normalImage == item.normalImage) {
            item.blackImage = data
            putBlackImage(
              imgPreviewType.value,
              currentPoliticalAction.application.actionId,
              imageData,
            )
          }
        })
      }
      //  報告書
      if (imgPreviewType.value == 'result') {
        const imageData = currentPoliticalAction.report.images
        imageData.forEach(item => {
          if (img.normalImage == item.normalImage) {
            item.blackImage = data
            putBlackImage(
              imgPreviewType.value,
              currentPoliticalAction.report.actionId,
              imageData,
            )
          }
        })
      }
      //  記録簿
      if (imgPreviewType.value == 'memory') {
        const imageData =
          currentPoliticalAction.memory.expenses[imgPreviewIndex.value].receipt
            .images
        imageData.forEach(item => {
          if (img.normalImage == item.normalImage) {
            item.blackImage = data
            putBlackImage(
              imgPreviewType.value,
              currentPoliticalAction.memory.actionId,
              imageData,
              currentPoliticalAction.memory.expenses[imgPreviewIndex.value]
                .receipt.id,
            )
          }
        })
      }
      //  諸経費
      if (imgPreviewType.value == 'receipt') {
        const imageData = currentReceipt.images
        imageData.forEach(item => {
          if (img.normalImage == item.normalImage) {
            item.blackImage = data
            putBlackImage(imgPreviewType.value, currentReceipt.id, imageData)
          }
        })
      }
      chengeEditMode.value = false
      canvasWidth.value = ''
      canvasHeight.value = ''
    }

    // 黒塗り表示ON/OFF
    const chengeImgPreview = () => {
      if (chengeImgPreviewFlag.value) {
        return (chengeImgPreviewFlag.value = false), (hideMenu.value = false)
      }
      if (!chengeImgPreviewFlag.value) {
        return (chengeImgPreviewFlag.value = true), (hideMenu.value = true)
      }
    }

    const { currentImgPreview } = useDialog()
    const img = currentImgPreview.value

    return {
      setImage,
      setNewImage,
      ...useDialog(),
      ...useCurrentUser(),
      img,
      CanvasElement,
      DivElement,
      image,
      canvasWidth,
      canvasHeight,
      saveImage,
      chengeImgPreview,
      blackImagePreview,
      chengeImgPreviewFlag,
      endEditMode,
      chengeEditMode,
      hideMenu,
      imgPreviewType,
      imgPreviewIndex,
      imageAspectRatio,
      rectState,
      rectHeight,
      rectWidth,
      rectCtx,
    }
  },
}
</script>

<style lang="scss">
#imgEdit {
  .menu-wrap {
    position: absolute;
    left: 50%;
    bottom: 0px;
    transform: translateX(-50%);
    -webkit-transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    width: 432px;
    height: 152px;
    border: solid 2px #fff;
    border-bottom: none;
    border-radius: 30px 30px 0 0;
    z-index: 600;
    .end-button-wrap {
      position: absolute;
      right: 0;
      width: 70px;
      height: 30px;
      border-radius: 100px;
      // z-index: 600;
      .circle {
        position: absolute;
        top: 4px;
        left: 3px;
        width: 22px;
        height: 22px;
        border-radius: 100px;
        border: solid;
      }
    }
    .button-wrap {
      margin-left: 10px;
      margin-top: 10px;
      width: 200px;
      height: 90px;
      border-radius: 20px 20px 20px 20px;
      // z-index: 600;
    }
  }
  .new-black-item {
    position: absolute;
    left: 50%;
    bottom: 0px;
    transform: translateX(-50%);
    -webkit-transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    width: 432px;
    height: 50px;
    border: solid 2px #fff;
    border-bottom: none;
    border-radius: 30px 30px 0 0;
    z-index: 600;
    .save-botton {
      position: absolute;
      right: 85px;
      width: 100px;
      height: 30px;
      border-radius: 100px;
      // z-index: 600;
      ApprovedIcn {
        position: absolute;
        top: 4px;
        left: 3px;
      }
    }
    .end-button-wrap {
      position: absolute;
      right: 0;
      width: 70px;
      height: 30px;
      border-radius: 100px;
      // z-index: 600;
      .circle {
        position: absolute;
        top: 4px;
        left: 3px;
        width: 22px;
        height: 22px;
        border-radius: 100px;
        border: solid;
      }
    }
  }
  .circle-bottom {
    position: absolute;
    left: 50px;
    top: -50px;
    width: 300px;
    height: 150px;
    border-radius: 0 0 150px 150px;
    z-index: 600;
  }
  .img-wrap {
    width: calc(100vw - 80px);
    height: calc(100vh - 80px);
    border: 2px solid #2993ce;
    outline: 2px solid #fff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);

    .preview-img {
      display: block;
      // width: 100%;
      // height: auto;
      margin: 0 auto;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
    }
    #canvas {
      display: block;
      position: absolute;
      margin: 0 auto;
      top: 0;
      right: 0;
      left: 0;
      z-index: 0;
    }
    #canvas-display {
      display: block;
      position: absolute;
      margin: 0 auto;
      top: 0;
      right: 0;
      left: 0;
      z-index: 1;
    }
  }
  .close-button {
    width: 40px;
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
    padding-top: 7px;
    padding-left: 7px;
    position: absolute;
    top: 24px;
    right: -16px;
  }
  .close-button:after {
    content: '';
    border: solid 2px #fff;
    border-bottom-right-radius: 25px;
    border-top-right-radius: 25px;
    border-left: none;
    position: absolute;
    top: -4px;
    left: 0;
    width: calc(100% + 4px);
    height: calc(100% + 8px);
    z-index: -1;
  }
}
</style>
